module.exports = __webpack_public_path__ + "img/small-3.c3f1aa07.webp";